import React from 'react'

const ProgressPending = ({ progress }) => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M1.5 16C1.5 7.99187 7.99187 1.5 16 1.5C24.0081 1.5 30.5 7.99187 30.5 16C30.5 24.0081 24.0081 30.5 16 30.5C7.99187 30.5 1.5 24.0081 1.5 16Z"
				fill="#FAFAFA"
			/>
			<path
				d="M1.5 16C1.5 7.99187 7.99187 1.5 16 1.5C24.0081 1.5 30.5 7.99187 30.5 16C30.5 24.0081 24.0081 30.5 16 30.5C7.99187 30.5 1.5 24.0081 1.5 16Z"
				stroke="#F4F4F5"
				strokeWidth="3"
			/>

			<text x="50%" y="50%" fontFamily="Inter" fontSize="14" fill="#777" fontWeight="700" letterSpacing="0.1" textAnchor="middle" dominantBaseline="central">
				{progress}
			</text>
		</svg>
	)
}

export { ProgressPending }
